// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../Config.bs.js";
import * as NetworkUtils from "../../../library/utils/NetworkUtils.bs.js";
import * as CountryConfig from "../../../country/CountryConfig.bs.js";
import * as Logger$Catalyst from "../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as IncentiveRepoConfig from "./IncentiveRepoConfig.bs.js";

function fetchCampaign(msisdn, auth_token, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/driver/api/v1/payout/campaigns/progress/TRIP_BASED_INCENTIVE?msisdn=" + msisdn);
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: msisdn
      });
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    authtoken: auth_token,
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(IncentiveRepoConfig.IncentiveCampaignResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var IncentiveRepo = {
  fetchCampaign: fetchCampaign
};

export {
  IncentiveRepo ,
  
}
/* Config Not a pure module */
